import {
  GAME_ID,
  ALEX_SPEAK,
  ALEX_SILENT,
  ALEX_SILENT_STATE,
  ALEX_SPEAK_STATE,
} from '../data/goblinGourmetConstants';

const initialState = { alexState: ALEX_SILENT_STATE };

const goblinGourmetAlexReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case ALEX_SILENT: {
      return { alexState: ALEX_SILENT_STATE };
    }
    case ALEX_SPEAK: {
      return { alexState: ALEX_SPEAK_STATE };
    }
    default:
      return state;
  }
};

export default goblinGourmetAlexReducer;
